import { useContext, useEffect } from "react"
import { AikaTipsContext } from "../../contexts/TipsProvider.context"

const useAikaTipsContext = () => {
  const data = useContext(AikaTipsContext)
  return data
}

export default useAikaTipsContext
